// Everything is 42
import moment from "moment";
import { boolean, number, object, string } from "yup";

export const subscriberValidations = object({
  first_name: string().min(1).max(25).required("This field is required"),
  last_name: string().min(1).max(25).required("This field is required"),
  email: string()
    .required("This field is required")
    .min(6)
    .max(255)
    .email("Invalid email")
    .test("pattern", "Email is not valid", (value) => {
      return Boolean(
        value &&
        /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.((?!con$)[a-zA-Z0-9]{2,12})$/.exec(
          value
        )
      );
    }),
  phone: string()
    .required("This field is required")
    .length(10, "Phone number must be 10 digits"),
  lease_end_date: string()
    .test(
      "optional-if-month-to-month",
      "This field is required",
      function (value) {
        return this.parent.lease_month_to_month || value;
      }
    )
    .test(
      "ongoing-lease",
      "Lease end date must be in the the future",
      function (value) {
        return this.parent.lease_month_to_month || !value
          ? true
          : moment(value).isSameOrAfter(moment().subtract(1, "day"));
      }
    ),
  lease_month_to_month: boolean(),
  monthly_rent_amount: number().required("This field is required"),
  dob: string()
    .required("This field is required")
    .test(
      "must_be_18_years_old",
      "Must be at least 18 years old",
      function (value) {
        return moment().diff(moment(value), "years") >= 18;
      }
    )
    .test("dob", "Invalid date of birth", function (value) {
      return value ? moment(value).isValid() : true;
    }),
  property_id: number().required("This field is required"),
  unit_id: number().required("This field is required"),
  address1: string().min(1).max(255).required("This field is required"),
  address2: string().max(255).optional(),
  city: string().min(1).max(25).required("This field is required"),
  state: string().min(1).max(25).required("This field is required"),
  zip: number().required("This field is required"),
  move_in_date: string()
    .optional()
    .test("move-in-date", "Invalid move-in date", function (value) {
      return !value || moment(value).isValid();
    })
    .test(
      "move-in-before-lease-end",
      "Move-in date must be before lease end date",
      function (value) {
        if (!value || !this.parent.lease_end_date) return true;
        return moment(value).isSameOrBefore(moment(this.parent.lease_end_date));
      }
    ),
  ssn: string()
    .optional()
    .test("ssn_length", "SSN must be 9 digits", function (value) {
      if (!value) return true;
      // Check if it's the masked format (***-**-XXXX)
      if (value.includes("*")) return true;
      // Otherwise validate that it's 9 digits
      const digits = value.replace(/\D/g, "");
      return digits.length === 9;
    })
});
